import { createFileRoute } from '@tanstack/react-router'
import { InvoicesPage } from '../screens/Invoices'

export const Route = createFileRoute('/invoices')({
  component: InvoicesPage,
})
